import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import axios from "axios";
import {toast} from "react-toastify";

const ArchiveDeliveryModal = (props) => {
    const {
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => { },
        onComplete  = (delivery) => { },
        jobId       = null,
        orderId     = null,
        deliveryId  = null,
        id          = "archive-delivery-modal",
    } = props;

    const [submitting, setSubmitting]   = useState(false);
    const [job, setJob]                 = useState(null);
    const [delivery, setDelivery]       = useState(null);

    useEffect(() => {
        if (!!jobId && !!orderId && !!deliveryId) {
            load();
        }
    }, [jobId, orderId, deliveryId]);

    const load = () => {
        axios.get(route('web-api.job.order.delivery.config', {job: jobId, order: orderId, delivery_id: deliveryId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.delivery) {
                        setDelivery(response.data.delivery);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        axios.delete(route('web-api.job.order.delivery.destroy', {
            job:        jobId,
            order:      orderId,
            delivery:   deliveryId,
        }).toString())
            .then((response) => {
                setSubmitting(false);
                onComplete(deliveryId);
            })
            .catch((error) => {
                console.log(error);
                setSubmitting(false);
            });
    }

    const handleClose = () => {
        onCancel();
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleClose()}
            contentLabel="Delete Delivery"
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">Delete Delivery</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClose()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <p className="mb-3">
                        Are you sure you want to <b className="text-danger">delete</b> this delivery:
                    </p>
                    {!!job && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Job Name</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!job.name ? job.name : ""}</p>
                            </div>
                        </React.Fragment>
                    )}
                    {!!delivery && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Delivery Date</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!delivery.delivery_at_display ? delivery.delivery_at_display : "-"}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Assigned User</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!delivery.user_display ? delivery.user_display : "-"}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Delivery Status</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!delivery.status_display ? delivery.status_display : "-"}</p>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="submit"
                        className="btn btn-danger py-0 px-3 ml-0 py-0 mr-4"
                        onClick={() => setSubmitting(true)}
                        disabled={submitting || disabled}
                    >
                        {"Yes, Delete Delivery"}
                    </button>
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => handleClose()}
                    >
                        {"Cancel"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ArchiveDeliveryModal;
